import { BillingPeriod } from '@enmon/commons/lib/enmon';
import { defineMessages } from '@/components/formatted_message/FormattedMessage';

export const BILLING_PERIOD_TRANSLATED = defineMessages<BillingPeriod>({
  [BillingPeriod.Month]: { id: 'app.common.supplyPoint.billingPeriod.month' },
  [BillingPeriod.Quarter]: { id: 'app.common.supplyPoint.billingPeriod.quarter' },
  [BillingPeriod.HalfYear]: { id: 'app.common.supplyPoint.billingPeriod.halfYear' },
  [BillingPeriod.Year]: { id: 'app.common.supplyPoint.billingPeriod.year' },
  [BillingPeriod.PerInvoice]: { id: 'app.common.supplyPoint.billingPeriod.perInvoice' },
});
